import './index.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { Toaster } from './components/ui/toast.js';
import { useIntl } from './hooks/useIntl';
import { initSentry } from './lib/sentry.js';
import IntlProvider from './providers/IntlProvider';
import { ThemeProvider } from './providers/ThemeProvider';

initSentry();

const LocalizedToaster = () => {
  const intl = useIntl();

  return <Toaster closeLabel={intl.formatMessage({ id: 'common.close' })} />;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider>
          <IntlProvider>
            <App />
            <LocalizedToaster />
          </IntlProvider>
        </ThemeProvider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>,
);
